import { breakpoints } from 'Components/ThemeProvider';

import arrow from 'assets/images/landingPages/stylingGel/arrow.svg';
import testimonial1Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_1.jpg';
import testimonial2Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_2.jpg';
import testimonial3Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_3.jpg';
import testimonial4Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_4.jpg';
import testimonial5Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_5.jpg';
import testimonial6Desktop from 'assets/images/landingPages/stylingGel/d-testimonials_6.jpg';
import quannSisters from 'assets/images/landingPages/stylingGel/dreamteam-1.jpg';
import gioF from 'assets/images/landingPages/stylingGel/dreamteam-2.jpg';
import michelleB from 'assets/images/landingPages/stylingGel/dreamteam-3.jpg';
import onaD from 'assets/images/landingPages/stylingGel/dreamteam-4.jpg';
import howToImg1 from 'assets/images/landingPages/stylingGel/howTo1.jpg';
import howToImg2 from 'assets/images/landingPages/stylingGel/howTo2.jpg';
import howToImg3 from 'assets/images/landingPages/stylingGel/howTo3.jpg';
import howToImg4 from 'assets/images/landingPages/stylingGel/howTo4.jpg';
import howToImg5 from 'assets/images/landingPages/stylingGel/howTo5.jpg';
import howToImg6 from 'assets/images/landingPages/stylingGel/howTo6.jpg';
import icon1 from 'assets/images/landingPages/stylingGel/icon-1.svg';
import icon2 from 'assets/images/landingPages/stylingGel/icon-2.svg';
import icon3 from 'assets/images/landingPages/stylingGel/icon-3.svg';
import ingredientAloe from 'assets/images/landingPages/stylingGel/ing-aloe.png';
import ingredientOkra from 'assets/images/landingPages/stylingGel/ing-okra.png';
import ingredientSeaMoss from 'assets/images/landingPages/stylingGel/ing-sea-moss.png';
import aboutStylingGel from 'assets/images/landingPages/stylingGel/lp-define-your-style.jpg';
import aboutStylingGel2 from 'assets/images/landingPages/stylingGel/lp-define-your-style2.jpg';
import aboutStylingGel3 from 'assets/images/landingPages/stylingGel/lp-define-your-style3.jpg';
import fallbackImage from 'assets/images/landingPages/stylingGel/lp-hero-fallback.jpg';
import productCarrousel1 from 'assets/images/landingPages/stylingGel/lp-product-1.jpg';
import productCarrousel2 from 'assets/images/landingPages/stylingGel/lp-product-2.jpg';
import productCarrousel3 from 'assets/images/landingPages/stylingGel/lp-product-3.jpg';
import testimonial1Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_1.jpg';
import testimonial2Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_2.jpg';
import testimonial3Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_3.jpg';
import testimonial4Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_4.jpg';
import testimonial5Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_5.jpg';
import testimonial6Mobile from 'assets/images/landingPages/stylingGel/m-testimonials_6.jpg';
import naturalWondersDesktop from 'assets/images/landingPages/stylingGel/naturalWondersDesktop.jpg';
import naturalWondersDesktop2 from 'assets/images/landingPages/stylingGel/naturalWondersDesktop2.jpg';
import naturalWondersMobile from 'assets/images/landingPages/stylingGel/naturalWondersMobile.jpg';
import naturalWondersMobile2 from 'assets/images/landingPages/stylingGel/naturalWondersMobile2.jpg';
import naturalWondersTablet from 'assets/images/landingPages/stylingGel/naturalWondersTablet.jpg';
import naturalWondersTablet2 from 'assets/images/landingPages/stylingGel/naturalWondersTablet2.jpg';
import stylingGelBackgroundDesktop from 'assets/images/landingPages/stylingGel/stylingGelBackgroundDesktop.jpg';
import stylingGelBackgroundDesktop2 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundDesktop2.jpg';
import stylingGelBackgroundDesktop3 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundDesktop3.jpg';
import stylingGelBackgroundDesktop4 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundDesktop4.jpg';
import stylingGelBackgroundMobile from 'assets/images/landingPages/stylingGel/stylingGelBackgroundMobile.jpg';
import stylingGelBackgroundMobile2 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundMobile2.jpg';
import stylingGelBackgroundMobile3 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundMobile3.jpg';
import stylingGelBackgroundMobile4 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundMobile4.jpg';
import stylingGelBackgroundTablet from 'assets/images/landingPages/stylingGel/stylingGelBackgroundTablet.jpg';
import stylingGelBackgroundTablet2 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundTablet2.jpg';
import stylingGelBackgroundTablet3 from 'assets/images/landingPages/stylingGel/stylingGelBackgroundTablet3.jpg';
import testimonial1Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_1.jpg';
import testimonial2Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_2.jpg';
import testimonial3Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_3.jpg';
import testimonial4Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_4.jpg';
import testimonial5Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_5.jpg';
import testimonial6Tablet from 'assets/images/landingPages/stylingGel/t-testimonials_6.jpg';

export const HeroSectionContent = {
  headline: 'curl outside the lines',
  subHead: 'Meet the first custom, clean & multi-use styling gel',
  fallbackImage,
  videoDesktop: 'lp-hero-desktop',
  videoMobile: 'lp-hero-mobile',
  arrowDown: arrow,
};

export const aboutStylingGelContent = {
  headline: 'define your own style',
  subHead: (
    <>
      Whether you want your hair to stay put or go with the flow, Styling Gel adapts to fit your
      hair texture, your lifestyle, and your city. <br />
      <br /> Every formula features a blend of naturally effective ingredients, including okra, aloe
      vera, and sea moss, to give curls the right amount of hold, definition, and versatility.{' '}
    </>
  ),
  ctaText: 'Shop Styling Gel',
  image: {
    src: aboutStylingGel,
  },
  coilyImage: {
    src: aboutStylingGel2,
    alt: 'A person wearing suit on orange background',
  },
  curlImage: {
    src: aboutStylingGel3,
    alt: '',
  },
};

export const formula = {
  title: 'Natural wonders',
  description:
    "Bottled fresh to order in our Brooklyn lab, your Styling Gel is packed with clean, sustainably sourced ingredients that are tailored to meet your specific needs. The result: A formula that's better for your hair and better for the planet.",
  altFormulaImages: [
    {
      src: naturalWondersMobile2,
      breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
    },
    {
      src: naturalWondersTablet2,
      breakpoint: `(max-width: ${breakpoints.md - 1}px)`,
    },
    {
      src: naturalWondersDesktop2,
      breakpoint: `(min-width: ${breakpoints.md - 1}px)`,
    },
  ],
  formulaImages: [
    {
      src: naturalWondersMobile,
      breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
    },
    {
      src: naturalWondersTablet,
      breakpoint: `(max-width: ${breakpoints.md - 1}px)`,
    },
    {
      src: naturalWondersDesktop,
      breakpoint: `(min-width: ${breakpoints.md}px)`,
    },
  ],
  naturalIngredients: [
    {
      name: 'OKRA',
      image: ingredientOkra,
      benefit: 'Helps control frizz & boost definition',
    },
    {
      name: 'ALOE VERA',
      image: ingredientAloe,
      benefit: 'Helps control frizz and shrinkage',
    },
    {
      name: 'SEA MOSS',
      image: ingredientSeaMoss,
      benefit: 'Helps lock in moisture & smooth curls',
    },
  ],
};

export const productStylingGelContent = {
  headline: 'your crown, customized',
  ctaText: 'get your styling gel',
  subHead: 'Switch up your style with our custom, made-to-order hair gel with benefits like:',
  productCapacity: '8.5 fl oz',
  benefits: [
    'Clean ingredients',
    'Customizable hold level',
    'Lightweight formula',
    'Controls frizz and shrinkage',
    'No flakes or crunch',
    'Protects against environmental damage',
  ],
  images: [
    {
      alt: 'styling gel product pot on purple background',
      image: productCarrousel1,
    },
    {
      alt: 'photo of styling gel texture',
      image: productCarrousel2,
    },
    {
      alt: 'styling gel product pot with its ingredients',
      image: productCarrousel3,
    },
  ],
};

export const howProseWorksContent = {
  headline: 'How prose works',
  sectionContent: [
    {
      title: '1. answer your questions',
      body: 'With ​​lab innovation and high-performance naturals, Prose creates effective products as unique as your curls. Our consultation analyzes over 85 factors to find what your hair truly needs.',
      icon: icon1,
    },
    {
      title: '2. get your custom products',
      body: 'Pair your Styling Gel with a whole customized routine for haircare that’s one-in-a-million. Discover your routine: from shampoo to supplements, we’ve got you covered.',
      icon: icon2,
    },
    {
      title: '3. review & Refine as you go',
      body: 'When you adapt, we adapt. Give us feedback, and we’ll adjust your products anytime. Continue rating your formulas for personalized haircare that keeps getting better.',
      icon: icon3,
    },
  ],
};

export const altHeroImage1 = [
  {
    image: stylingGelBackgroundMobile,
    breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
  },
  {
    image: stylingGelBackgroundTablet,
    breakpoint: `(max-width: ${breakpoints.md - 1}px)`,
  },
  {
    image: stylingGelBackgroundDesktop,
    breakpoint: `(min-width: ${breakpoints.md}px)`,
  },
];

export const heroImage1 = [
  {
    image: stylingGelBackgroundMobile2,
    breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
  },
  {
    image: stylingGelBackgroundTablet2,
    breakpoint: `(min-width: ${breakpoints.md}px)`,
  },
  {
    image: stylingGelBackgroundDesktop2,
    breakpoint: `(min-width: ${breakpoints.md}px)`,
  },
];

export const altHeroImage2 = [
  {
    image: stylingGelBackgroundMobile4,
    breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
  },
  {
    image: stylingGelBackgroundDesktop4,
    breakpoint: `(min-width: ${breakpoints.md}px)`,
  },
];

export const heroImage2 = [
  {
    image: stylingGelBackgroundMobile3,
    breakpoint: `(max-width: ${breakpoints.sm - 1}px)`,
  },
  {
    image: stylingGelBackgroundTablet3,
    breakpoint: `(max-width: ${breakpoints.md - 1}px)`,
  },
  {
    image: stylingGelBackgroundDesktop3,
    breakpoint: `(min-width: ${breakpoints.md}px)`,
  },
];

export const dreamTeamContent = {
  sectionTitle: 'Meet the advisory board',
  SectionbodyText:
    'When thousands of customers asked for a personalized hair styling gel that could do everything, we tapped a group of passionate curl experts to help us deliver. Meet the Haircare Advisory Board behind the product of your dreams.',
  cardsData: [
    {
      title: (
        <>
          the
          <br />
          quann
          <br />
          sisters
        </>
      ),
      image: quannSisters,
      alt: 'photo portrait of 2 women influencers urban bush babes',
      caption: 'Curl/Coil Hair Experts & Influencers',
      bodyText:
        '“Co-developing Styling Gel was our first experience with a natural ingredients gel that worked for our hair texture. They truly listened to our feedback.”',
    },
    {
      title: (
        <>
          gio <br /> ferrer
        </>
      ),
      image: gioF,
      alt: 'photo portrait of Gio Ferrer',
      caption: 'Hair Content Creator & Curl Expert',
      bodyText:
        '“When I tested my last formula, it shocked me because I don’t find products that I’m Iike OMG I’m going to use this again. I’m so happy with the results.”',
    },
    {
      title: (
        <>
          michelle <br /> breyer
        </>
      ),
      image: michelleB,
      alt: 'photo portrait of Michelle Breyer',
      caption: 'Founder of NaturallyCurly.com',
      bodyText:
        '“I got to create my own Holy Grail product, changing the formula to meet my climate. Not to mention, I’ve regularly received compliments on my curls.”',
    },
    {
      title: (
        <>
          Ona <br /> Diaz
        </>
      ),
      image: onaD,
      alt: 'photo portrait of Ona Diaz',
      caption: 'Owner of 5Salon&Spa & Hair Stylist',
      bodyText:
        '“It was great working with Prose co-developing styling gel. I’m happy to see brands care for curly hair as they represent a huge part of the population.”',
    },
  ],
};

export const videosContent = {
  headlines: ['slick it down.', 'twist it out.', 'go all out.'],
  subHead: 'How to change up your look',
  videos: [
    {
      howToCaption: 'Wash & go with brittany',
      url: 'sgHowTo1',
      productsCaption: 'Shampoo, conditioner, curl cream + styling gel',
      image: howToImg1,
      dataClick: 'slide-1-play',
    },
    {
      howToCaption: 'Slicked back ponytail with faith',
      url: 'sgHowTo2',
      productsCaption: 'Styling gel',
      image: howToImg2,
      dataClick: 'slide-1-play',
    },
    {
      howToCaption: 'Flexi-rod curls with logan',
      url: 'sgHowTo3',
      productsCaption: 'Styling gel + Hair oil',
      image: howToImg3,
      dataClick: 'slide-1-play',
    },
  ],
  curlVideos: [
    {
      howToCaption: 'Wash & go with brittany',
      url: 'sgHowTo1',
      productsCaption: 'Shampoo, conditioner, curl cream + styling gel',
      image: howToImg1,
      dataClick: 'slide-1-play',
    },
    {
      howToCaption: 'Slicked back ponytail with faith',
      url: 'sgHowTo2',
      productsCaption: 'Styling gel',
      image: howToImg2,
      dataClick: 'slide-2-play',
    },
    {
      howToCaption: 'Styled edges with faith',
      url: 'sgHowTo4',
      productsCaption: 'Styling gel',
      image: howToImg4,
      dataClick: 'slide-3-play',
    },
  ],
  coilyVideos: [
    {
      howToCaption: 'Flexi-rod curls with logan',
      url: 'sgHowTo3',
      productsCaption: 'Styling gel + Hair oil',
      image: howToImg3,
      dataClick: 'slide-1-play',
    },
    {
      howToCaption: 'Wash & go with carlton',
      url: 'sgHowTo5',
      productsCaption:
        'Hair Mask, Shampoo, Conditioner, Leave-In, Curl Cream, Styling Gel, + Hair Oil',
      image: howToImg5,
      dataClick: 'slide-2-play',
    },
    {
      howToCaption: 'Brush coils with nigella',
      url: 'sgHowTo6',
      productsCaption: 'Shampoo, conditioner, curl cream, styling gel + hair oil',
      image: howToImg6,
      dataClick: 'slide-3-play',
    },
  ],
};

export const faq = {
  headline: 'Frequently asked questions',
  questions: [
    {
      question: 'What hair textures does Prose Custom Styling Gel work for?',
      answer:
        'Prose Styling Gel is custom formulated for versatile styling on textures ranging from waves to coils (and everything in between). Personalized based on your preferences, it provides the right amount of hold without flakes or crunch.',
    },
    {
      question: 'How do I use Styling Gel?',
      answer:
        'Prose Styling Gel is versatile and can be used to create and maintain a variety of hairstyles. This includes, but isn’t limited to: wash n’ gos, slicked styles, braids, edges, and twists. For best results, we recommend applying it on wet hair.',
    },
    {
      question: 'Can I layer my styling gel with other styling products?',
      answer: (
        <>
          Yes! Prose Styling Gel fits seamlessly into your haircare routine. Layer it with other
          stylers such as Curl Cream or Leave-in Conditioner for extra shine, hold, and definition
          plus nourishment for your strands. You can learn more about how to layer different styling
          products <a href="https://prose.com/blog/loc-method-hair.php">here</a>.
        </>
      ),
    },
    {
      question: 'How much hold does Styling Gel provide?',
      answer:
        'Your Prose Styling Gel will be customized to provide the ideal level of hold for your hair based on the results of your consultation. And don’t worry–it’ll never flake or crunch!',
    },
    {
      question: 'Why does Prose Custom Styling Gel look different from other gels that I’ve used?',
      answer:
        'Prose Styling Gel is an innovative formula with natural ingredients that can cause variations in each batch. The product may look cloudy, but that’s normal. The color has no impact on the formula’s freshness, efficacy, or consistency.',
    },
    {
      question: 'What ingredients are NOT included in Prose Custom Styling Gel formulas?',
      answer:
        'Prose Custom Styling Gel is customized to your needs using clean, innovative ingredients to provide hold, care, and protection. It will always be made without the following: alcohol, silicone, parabens, phthalates, GMOs, sulfates, and mineral oil. Like all Prose products, Custom Styling Gel is cruelty-free.',
    },
  ],
};

export const curlTestimonialsContent = {
  title: 'Hair tips & tricks',
  images: [
    {
      alt: 'woman with slicked-back pony',
      mobile: { image: testimonial4Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial4Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial4Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with afro buns and long hair',
      mobile: { image: testimonial2Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial2Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial2Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with short natural afro hair',
      mobile: { image: testimonial3Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial3Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial3Desktop,
        width: 1440,
        height: 1174,
      },
    },
  ],
  legends: [{ text: 'Faith Type 3C' }, { text: 'Michelle Type 2C' }, { text: 'Ona Type 3B' }],
  testimonies: [
    '“I love that no matter which hold I choose I can still get the same benefits from custom styling gel - frizz free curls, humidity protection, and styles that last!”',
    '“I have high porosity hair, so humidity is a big concern for me. With Prose Styling Gel, my hairstyle withstood a mile long walk, on a really humid night! This product is a winner!”',
    '“I think for me, my favorite part of using this gel is that it’s customized to my hair needs. It’s not too heavy for my fine hair which has been so satisfying and truly this girl’s dream come true!”',
  ],
  proTip: {
    title: 'Pro tip:',
    text: [
      '“After smoothing down with styling gel, wrap hair with a silk scarf for 10 mins to control stubborn flyaways.”',
      '“To boost volume, I rub a bit of product in my hand, bend over and scrunch it into my hair before diffusing.”',
      '“When using a styling gel, start and finish by applying multiple small amounts to avoid oversaturation too quickly.”',
    ],
  },
  productsUsed: {
    title: 'Prose Products Used:',
    text: [
      'Shampoo, Conditioner, Styling Gel',
      'Shampoo, Conditioner, Styling Gel',
      'Shampoo, Conditioner, Leave-In Conditioner, Styling Gel',
    ],
  },
};

export const coilyTestimonialsContent = {
  title: 'Hair tips & tricks',
  images: [
    {
      alt: 'woman with afro ponytail locs wearing a white top and a bleached jean',
      mobile: { image: testimonial1Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial1Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial1Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with long hair',
      mobile: { image: testimonial5Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial5Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial5Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with short natural afro hair',
      mobile: { image: testimonial6Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial6Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial6Desktop,
        width: 1440,
        height: 1174,
      },
    },
  ],

  legends: [{ text: 'Cipriana Type 4C' }, { text: 'TK Type 4C' }, { text: 'Nigella Type 4C' }],

  testimonies: [
    '“The Prose Styling Gel seamlessly fits into my routine of adding an extra layer of protection without all the bulk and sticky residue. Also, a little Prose Styling Gel goes a long way.”',
    '“Natural ingredients is the #1 factor I look for. It feels really good to know that with Prose styling gel I no longer have to worry about sacrificing hold for natural ingredients. I get to choose both with one product.”',
    '“I really enjoy my customized Prose products. Having 4C coils isn’t the easiest to manage, but it helps when you have products truly customized to my hair texture and what it needs.”',
  ],
  proTip: {
    title: 'Pro tip:',
    text: [
      '“To maintain longer lengths, outside of trimming, sealing your ends is pertinent to hair growth.”',
      '“When using a styling gel for my edges I always apply water then hair oils first to seal in moisture.”',
      '“Apply Prose Curl Cream evenly throughout your hair to retain moisture and lock in hydration with the Styling Gel.”',
    ],
  },
  productsUsed: {
    title: 'Prose Products Used:',
    text: [
      'Styling Gel, Hair Oil',
      'Styling Gel, Hair Oil',
      'Shampoo, Conditioner, Curl Cream, Styling Gel, Hair Oil',
    ],
  },
};

export const testimonialsContent = {
  title: 'Hair tips & tricks',
  images: [
    {
      alt: 'woman with afro ponytail locs wearing a white top and a bleached jean',
      mobile: { image: testimonial1Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial1Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial1Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with afro buns and long hair',
      mobile: { image: testimonial2Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial2Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial2Desktop,
        width: 1440,
        height: 1174,
      },
    },
    {
      alt: 'woman with short natural afro hair',
      mobile: { image: testimonial3Mobile, width: 628, height: 584 },
      tablet: {
        image: testimonial3Tablet,
        width: 768,
        height: 1008,
      },
      desktop: {
        image: testimonial3Desktop,
        width: 1440,
        height: 1174,
      },
    },
  ],
  legends: [{ text: 'Cipriana Type 4C' }, { text: 'Michelle Type 2C' }, { text: 'Ona Type 3B' }],
  testimonies: [
    '“The Prose Styling Gel seamlessly fits into my routine of adding an extra layer of protection, without all the bulk and sticky residue. Also, a little Prose Styling Gel goes a long way.”',
    '“I have high porosity hair, so humidity is a big concern for me. With Prose Styling Gel, my hairstyle withstood a mile long walk, on a really humid night! This product is going to be a winner!”',
    '“I think for me, my favorite part of using this gel is that it’s customized to my hair needs. It’s not too heavy for my fine hair which has been so satisfying and truly this girl’s dream come true!”',
  ],
  proTip: {
    title: 'Pro tip:',
    text: [
      '“To maintain longer lengths, outside of trimming, sealing your ends is pertinent to hair growth.”',
      '“To boost volume, I rub a bit of product in my hand, bend over and scrunch it into my hair before diffusing.”',
      '“When using a styling gel, start and finish by applying multiple small amounts to avoid oversaturation too quickly.”',
    ],
  },
  productsUsed: {
    title: 'Prose Products Used:',
    text: [
      'Styling Gel, Hair Oil',
      'Shampoo, Conditioner, Styling Gel',
      'Shampoo, Conditioner, Leave-In Conditioner, Styling Gel',
    ],
  },
};
